<template>
  <div>
    <h2>Redirecting...</h2>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

onMounted(() => {
  window.open('https://big:money@nextcloud.rossinienergy.com/re_images/');
  router.push('/');
});
</script>

<style scoped>

</style>
